import { useParams } from 'react-router-dom';
import JobsView from './DeliveriesView';
import React from 'react';
import DeliveriesView from './DeliveriesView';

const DeliveriesViewWrapper = () => {
  const { userId } = useParams<{ userId: string }>();
  return <DeliveriesView userId={userId ? parseInt(userId) : null} />;
};

export default DeliveriesViewWrapper;